import cButton from '#themes/default/default/components/button/button.js';
import cHeader from '#themes/default/default/components/header/header.js';

import paymentFailureText from '#frontend/util/paymentFailureText.js';

import template from './paymentFailedModal.html' with { type: 'html' };

export default {
	name: 'CPaymentFailedModal',
	components: {
		cButton,
		cHeader
	},
	props: {
		payment: {
			type: Object,
			default: () => {}
		}
	},
	computed: {
		getPaymentFailureText() {
			return paymentFailureText(this.t, this.payment);
		}
	},
	template
};
